import { LocationDto } from "@braoshzmvavz/picnube-common";
import { Button, Group, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";

export default function LocationEditForm(props: {
  location: LocationDto | null;
  onSubmit: (location: LocationDto) => void;
}) {
  const form = useForm({
    mode: "controlled",
    initialValues: {
      name: props.location?.name ?? "",
    },

    validate: (values) => {
      return {
        name:
          values.name.trim().length < 2
            ? "Name must include at least 2 characters"
            : null,
      };
    },
  });

  return (
    <Group
      align="end"
      className="flex w-full dark:bg-[#393939] bg-grey-100 p-4 rounded-lg max-w-96"
    >
      <div className="flex-1 flex flex-col">
        <TextInput
          required
          label="Location name"
          className="flex-1"
          placeholder="Home"
          {...form.getInputProps("name")}
        />
      </div>

      <Button
        disabled={!form.isValid()}
        onClick={() =>
          props.onSubmit({ ...props.location, name: form.values.name })
        }
      >
        Confirm
      </Button>
    </Group>
  );
}
